import { DISORDER_LIST, PHOBIA_ACTION_MAP } from "@/config";
import { generate } from "shortid";
import { PAGE_THEMES } from "../../types";
import { getCategoryById } from "@/utils";

export const REFERRER_WELCOME_PAGES = {
  referrer_choose_problem_page: {
    id: `referrer_choose_problem_page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "referral_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "anxiety_profile_comfortability_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 4:
              return title.replace("{{phobia}}", "social situations");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 4:
              return "anxiety_profile_goals_info_page";
            default:
              return "celebrate_page";
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.title;
          }

          return null;
        },
      },
      {
        name: "phobia_info_page",
        data_key: "description",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.description;
          }

          return null;
        },
      },
      {
        name: "treatment_select_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return `Have you tried treating your ${getCategoryById(
              data
            ).title.toLocaleLowerCase()}?`;
          }

          return null;
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What do you need help with?",
      description: "Choose one that affects you most day to day",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-2-${generate()}`,
          label: "A phobia",
          to: "choose_phobia_page",
          text: "See all →",
          value: "phobia",
          target_field: "choose_problem",
          icon: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-0-${generate()}`,
          label: "Social Anxiety",
          to: "phobia_info_page",
          icon: "social-anxiety",
          value: 4,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Mild Depression",
          to: "phobia_info_page",
          icon: "programs/mild-depression",
          value: 1001,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  partnership_allianz_page: {
    id: `partnership-allianz-page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "referral_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 1013:
              return title.replace("{{phobia}}", "driving");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 1013:
              return PHOBIA_ACTION_MAP.allianz_driving.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 1013:
              return "therapist_developed_program_allianz";
            default:
              return "anxiety_profile_comfortability_page";
          }
        },
      },
      {
        name: "therapist_developed_program",
        data_key: "custom_back",
        action: (data) => {
          switch (data) {
            case 1013:
              return "anxiety_profile_fears_page";
            default:
              return "treatment_select_page";
          }
        },
      },
      {
        name: "program_how_vr_works_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 1013:
              return "web_payment_setup_account_page_allianz";
            default:
              return "web_payment_setup_account_page";
          }
        },
      },
      {
        name: "program_category_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 1013:
              return "program_clinical_lesson_page_allianz";
            default:
              return "program_clinical_lesson_page";
          }
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title:
        "Welcome to overcoming your fear of driving with oVRcome, supported by Allianz and endorsed by Sydney Phobia Clinic",
      description: "Choose 'Driving' to get started",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-1-${generate()}`,
          label: "Driving",
          to: "anxiety_profile_fears_page",
          icon: "amaxophobia",
          value: 1013,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  partnership_ease_up_page: {
    id: `partnership-ease-up-page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "referral_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "web_payment_success_page",
        data_key: "description",
        action: (data) => {
          let description =
            "Your subscription has started, and you'll receive a welcome email with details on how to access it. You should have also received the VR headset by now to enable you to continue with the program.";

          switch (data) {
            case 1012:
              return description;
            default:
              return "Your subscription has started and your headset is on its way. You'll be emailed a tracking code within 2 business days";
          }
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title:
        "Welcome to overcoming your vaping problem with Ease Up and oVRcome",
      description: "Choose 'Vaping' to get started",
      image: "ease-up-logo",
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-1-${generate()}`,
          label: "Vaping",
          to: "age_select_page_vaping",
          icon: "programs/vaping",
          value: 1012,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  partnership_moe_vaping_page: {
    id: `partnership-vaping-page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "referral_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "web_payment_success_page",
        data_key: "description",
        action: (data) => {
          let description =
            "Your subscription has started, and you'll receive a welcome email with details on how to access it. You should have also received the VR headset by now to enable you to continue with the program.";

          switch (data) {
            case 1012:
              return description;
            default:
              return "Your subscription has started and your headset is on its way. You'll be emailed a tracking code within 2 business days";
          }
        },
      },
      {
        name: "gender_select_page_vaping",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 1012:
              return [
                {
                  id: `option-item-0-${generate()}`,
                  label: "Male",
                  to: "ethnicity_page",
                  value: "male",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-1-${generate()}`,
                  label: "Female",
                  to: "ethnicity_page",
                  value: "female",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-2-${generate()}`,
                  label: "Non-binary",
                  to: "ethnicity_page",
                  value: "non-binary",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-3-${generate()}`,
                  label: "Prefer not to say",
                  to: "ethnicity_page",
                  value: "prefer_not_to_say",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
              ];
            default:
              return [
                {
                  id: `option-item-0-${generate()}`,
                  label: "Male",
                  to: "why_im_doing_this_program_vaping",
                  value: "male",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-1-${generate()}`,
                  label: "Female",
                  to: "why_im_doing_this_program_vaping",
                  value: "female",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-2-${generate()}`,
                  label: "Non-binary",
                  to: "why_im_doing_this_program_vaping",
                  value: "non-binary",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-3-${generate()}`,
                  label: "Prefer not to say",
                  to: "why_im_doing_this_program_vaping",
                  value: "prefer_not_to_say",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
              ];
          }
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Welcome to overcoming your vaping problem with oVRcome",
      description: "Choose 'Vaping' to get started",
      image: "",
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-1-${generate()}`,
          label: "Vaping",
          to: "age_select_page_vaping",
          icon: "programs/vaping",
          value: 1012,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  d2c_vaping_page: {
    id: `d2c-vaping-page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "referral_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "gender_select_page_vaping",
        data_key: "options",
        action: (data) => {
          switch (data) {
            default:
              return [
                {
                  id: `option-item-0-${generate()}`,
                  label: "Male",
                  to: "why_im_doing_this_program_vaping",
                  value: "male",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-1-${generate()}`,
                  label: "Female",
                  to: "why_im_doing_this_program_vaping",
                  value: "female",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-2-${generate()}`,
                  label: "Non-binary",
                  to: "why_im_doing_this_program_vaping",
                  value: "non-binary",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
                {
                  id: `option-item-3-${generate()}`,
                  label: "Prefer not to say",
                  to: "why_im_doing_this_program_vaping",
                  value: "prefer_not_to_say",
                  target_field: "choose_gender",
                  icon: null,
                  text: null,
                  description: null,
                  isActive: false,
                },
              ];
          }
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Welcome to overcoming your vaping problem with oVRcome",
      description: "Choose 'Vaping' to get started",
      image: "",
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-1-${generate()}`,
          label: "Vaping",
          to: "age_select_page_vaping",
          icon: "programs/vaping",
          value: 1012,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  partnership_whakarongorau_page: {
    id: `partnership_whakarongorau_page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "referral_welcome",
    backwards_navigation_enabled: false,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "anxiety_profile_comfortability_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 4:
              return title.replace("{{phobia}}", "social situations");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 4:
              return "anxiety_profile_goals_info_page";
            default:
              return "celebrate_page";
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.title;
          }

          return null;
        },
      },
      {
        name: "phobia_info_page",
        data_key: "description",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.description;
          }

          return null;
        },
      },
      {
        name: "treatment_select_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return `Have you tried treating your ${getCategoryById(
              data
            ).title.toLocaleLowerCase()}?`;
          }

          return null;
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title:
        "Welcome to overcoming Social Anxiety with Whakarongorau and oVRcome",
      description: "Choose 'Social Anxiety' to get started",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-social-anx-${generate()}`,
          label: "Social Anxiety",
          description: null,
          icon: "social-anxiety",
          target_field: "choose_phobias",
          to: "phobia_info_page",
          value: 4,
          content: "Fear of Social Situations",
          isActive: false,
        },
      ],
    },
  },
};
